import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import cn from 'classnames';
import RichText from 'legacy-src/utility/RichText';
import btn from 'legacy/src/utility/btn';
import { Icon } from 'legacy-packages/ft-cb';
import telemetry from 'legacy-src/utility/telemetry';

import ProseMirror from '../../ProseMirror';
import './free_response.scss';

@telemetry({})
class Player extends Component {
  static displayName = 'FreeResponse';

  static propTypes = {
    item: PropTypes.object,
    submission: PropTypes.object,
    feedback: PropTypes.object,
    context: PropTypes.object,
  };

  static breakpoints = {
    large: (e) => e.width > 710,
  };

  constructor(props) {
    super(props);

    this.state = { breakpoints: {} };
  }

  /**
   * Called when typing on ProseMirror editor
   **/
  @telemetry((props, state, args) => {
    const [content] = args;
    const { item, params } = props;

    return {
      event_type: 'typing_answer',
      params: {
        formated_text: content,
        assignment_id: Number(params.assignmentId),
        question_id: item.id,
        subject_id: Number(params.subject),
      },
    };
  })
  onTextEditorUpdate() {
    // This is just a placeholder to get the telemetry decorator triggered
    return true;
  }

  render() {
    const {
      item: { id, calculator_section, questionNumber, content },
      submission,
      saveDraft,
    } = this.props;
    const { response } = submission.state;
    const { print, showAnswers } = this.props.context;
    const scoreInfo = this.props.item.content.scoring;
    const frClasses = cn(
      'free_response_question',
      { 'free_response_question--large': this.state.breakpoints.large },
      { 'free_response_question--print': print },
    );

    const submitted =
      submission.state.submitted ||
      (submission[id] && submission[id].submitted);

    const calculatorIcon =
      (calculator_section && (
        <div className="calculator_allowed" title="Calculator allowed">
          <Icon name="calculator" size="1.2em" />
        </div>
      )) ||
      null;

    return (
      <div className={frClasses} data-am-type="questions/free_response">
        {calculatorIcon}
        {print && questionNumber ? (
          <h2 className="free_response__question_number">{questionNumber}.</h2>
        ) : null}
        <div className="free_response_question__stimulus">
          <RichText content={content.prompt} />
        </div>
        {/* Hide score input while printing */}
        {!print && (
          <div className="free_response_question__input">
            {submitted ? (
              response === undefined ? (
                <em>No response entered.</em>
              ) : (
                <RichText content={response} />
              )
            ) : (
              <ProseMirror
                valueLink={submission.cursor(['response'])}
                menu="student"
                onContentUpdate={(c) => this.onTextEditorUpdate(c)}
              />
            )}
            {!submitted && (
              <button
                className={btn({ color: 'light_blue' })}
                onClick={saveDraft}
              >
                Save
              </button>
            )}
          </div>
        )}
        {/* Show scoring guidelines as "asnwers" */}
        {showAnswers && print && (
          <div className="free_response_question__sg_wrapper">
            <h4 className="free_response_question__sg_heading">
              Scoring Guidelines
            </h4>
            {_.map(scoreInfo, (s, i) => (
              <div key={i} className="free_response_question__sg">
                <h5 className="free_response_question__sg_part_heading">
                  {s.title}
                </h5>
                <RichText text={s.description} />
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }
}

const status = ({ content }, state = {}) => {
  const { response, submitted } = state;
  const reviewing = submitted && response;

  const result = {
    viewed: state.viewed ? 1 : 0,
    selected: response ? 1 : 0,
    complete: reviewing ? 1 : response ? 0.5 : 0,
  };
  if (result.complete !== 1) {
    result.submittable = (!reviewing && response) || content.optional ? 1 : 0;
  }
  return result;
};

const version = ({ content }) =>
  /*
  Return a version based on the number of score categories and score options.
  */
  ({
    optional: content.optional,
    scoring: (content.scoring || []).map((s) => (s.scores || []).length),
  });
export default { Player, status, version };
